import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

type BreadcrumbItem = {
  label: string;
  to?: string;
};

const useBreadcrumbs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const path = location.pathname;

  const routeMap: Record<string, BreadcrumbItem[]> = {
    '/dashboard': [{ label: t('dashboard.breadcrumb-home'), to: '/dashboard' }],
    '/thema': [{ label: t('dashboard.breadcrumb-change-your-age'), to: '/thema' }],
    '/improvements': [{ label: t('dashboard.breadcrumb-improvements'), to: '/improvements' }],
    '/suggestions': [{ label: t('dashboard.breadcrumb-suggestions'), to: '/suggestions' }],
  };

  if (routeMap[path]) {
    return routeMap[path];
  }

  const fromPath = (location.state as { from: string })?.from;
  if (fromPath) {
    if (routeMap[fromPath]) {
      if (path && path.includes('/thema/')) {
        const themeName = decodeURIComponent(path.split('/thema/')[1] as string);
        return [{ label: routeMap[fromPath][0].label, to: fromPath }, { label: themeName }];
      }
      return routeMap[fromPath];
    }
  }

  return [];
};

export default useBreadcrumbs;
